import eventNameToFilename from './eventNameToFilename';

export default function makeUniqueFilename(eventName, usedFilenames) {
  let filename = eventNameToFilename(eventName);

  if (usedFilenames.has(filename)) {
    let counter = 1;
    while (usedFilenames.has(`${filename}_${counter}`)) {
      counter++;
    }
    filename = `${filename}_${counter}`;
  }

  return filename;
}
